import { Skeleton as MuiSkeleton, SkeletonProps } from '@mui/material';
import React from 'react';

export const Skeleton: React.FC<SkeletonProps> = React.forwardRef(
  (props: SkeletonProps, ref) => {
    return (
      <MuiSkeleton
        {...props}
        sx={{ ...props.sx, bgcolor: 'secondary.main' }}
        ref={ref}
      />
    );
  }
);
